/**
 * get the current locale from url
 */
export default () =>
  window.location.pathname.split('/')[1] === 'en' ? 'en' : 'zh'
